import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import ExternalStores from "@/components/ExternalStores";

export default function Shop() {
  const [params, setParams] = useSearchParams();
  const category = params.get("category") || "All";
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/categories").then((r) => setCategories(["All", ...r.data.categories]));
  }, []);

  useEffect(() => {
    setLoading(true);
    const cfg = category && category !== "All" ? { params: { category } } : {};
    api.get("/products", cfg)
      .then((r) => setProducts(r.data))
      .finally(() => setLoading(false));
  }, [category]);

  const setCat = (c) => {
    if (c === "All") setParams({});
    else setParams({ category: c });
  };

  return (
    <div className="pt-32 pb-20 min-h-screen" data-testid="shop-page">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <p className="overline mb-4">Boutique</p>
        <h1 className="font-display text-5xl md:text-7xl font-light text-white tracking-tighter">The Collection.</h1>
        <p className="text-white/60 mt-4 max-w-xl">Each piece is crafted in limited runs. Once it's gone — it's gone.</p>

        <div className="flex flex-wrap gap-3 mt-12 mb-14 border-b border-white/10 pb-6" data-testid="category-filter">
          {categories.map((c) => (
            <button key={c} onClick={() => setCat(c)}
              data-testid={`filter-${c.toLowerCase().replace(/\s/g, '-')}-btn`}
              className={`text-xs uppercase tracking-[0.18em] px-5 py-2.5 transition-all ${
                category === c
                  ? "bg-[var(--davide-gold)] text-black"
                  : "border border-white/20 text-white/70 hover:border-[var(--davide-gold)] hover:text-[var(--davide-gold)]"
              }`}>
              {c}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {[...Array(8)].map((_, i) => <div key={i} className="aspect-[3/4] bg-[#141414] animate-pulse"/>)}
          </div>
        ) : products.length === 0 ? (
          <div className="text-center py-20 text-white/50 font-display text-2xl" data-testid="no-products-msg">No pieces in this category yet.</div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-10">
            {products.map((p) => <ProductCard key={p.id} product={p} />)}
          </div>
        )}
      </div>
      <ExternalStores />
    </div>
  );
}
